import { Prisma } from '@prisma/client';
import { SupplierInclude } from '../includes/Supplier';
export var SupplierType;
(function (SupplierType) {
    SupplierType["STARTUP"] = "Startup";
    SupplierType["SCALEUP"] = "Scaleup";
    SupplierType["SME"] = "SME";
    SupplierType["PRELAUNCH"] = "Pre-Launch";
    SupplierType["CORPORATE"] = "Corporate";
    SupplierType["AGENCY"] = "Agency";
})(SupplierType || (SupplierType = {}));
var IncludeSupplier = Prisma.validator()({
    include: SupplierInclude,
});
//# sourceMappingURL=Supplier.js.map